import { Component } from '@angular/core';

import {FiltersService} from './filters.service';
import {ApiService} from './../shared/api.service';
import {Utils} from '../utils';

@Component({
    selector: 'filters-component',
    templateUrl: 'filters.component.html'
})
export class FiltersComponent {
    panelOpen = false;
    filtersAnonymous = this.utils.rand();
    filtersDatePicker = this.utils.rand();
    filtersDatePicker2 = this.utils.rand();
    filtersDatePicker3 = this.utils.rand();
    constructor(public fs: FiltersService, private api: ApiService, private utils: Utils) {
    }
    togglePanel() {
        this.panelOpen = !this.panelOpen;
    }
    matcherComp(option, selected) {
        return option && selected ? option.name === selected.name : option === selected;
    }
    fieldComp(option, selected) {
        return option && selected ? option.column === selected.column : option === selected;
    }    
}